
const marginPayTypeOptions = {
  resetOptions (form, HouseKeys) {
    const version = form.version || 0
    if (version >= 20240501) {
      this.v20240501(form, HouseKeys)
    } else {
      this.default(form, HouseKeys)
    }
  },
  default (form, HouseKeys) {
    console.log('default resetOptions', form, HouseKeys)
  },
  v20240501 (form, HouseKeys) {
    if (form.regionId === 'x00004') {
      const hidden = !/^3505\d{2}$/.test(form.REGION_CODE)
      const { MARGIN_PAY_TYPE } = HouseKeys.MARGIN_PAY_TYPE
      const { MARGIN_PAY_TYPE_SIGNOUT_NO } = HouseKeys.MARGIN_PAY_TYPE_SIGNOUT_NO
      const yearType = MARGIN_PAY_TYPE.Options.find((obj) => {
        return obj.Value === '年度投标保证金'
      })
      var yearNo = MARGIN_PAY_TYPE_SIGNOUT_NO.Options.find((obj) => {
        return obj.Name.indexOf('年度投标保证金') === 1
      })
      if (yearType) {
        yearType.Hidden = hidden
        if (hidden && form.MARGIN_PAY_TYPE) {
          var index = form.MARGIN_PAY_TYPE.indexOf(yearType.Value)
          if (index >= 0) form.MARGIN_PAY_TYPE.splice(index, 1)
        }
      }
      if (yearNo) {
        yearNo.Hidden = hidden
        if (hidden && form.MARGIN_PAY_TYPE_SIGNOUT_NO) {
          var index = form.MARGIN_PAY_TYPE_SIGNOUT_NO.indexOf(yearNo.Value)
          if (index >= 0) form.MARGIN_PAY_TYPE_SIGNOUT_NO.splice(index, 1)
        }
      }
    }
  }
}


export default {
  init (win) {
    win.$sx = {
      version: 20240501,
      marginPayTypeOptions: marginPayTypeOptions
    }
    return win
  }
}